import { extractCleanedClause } from "./extractor";
import { Clause } from ".";

export function cleanApiClause(clause: Clause) {
  return extractCleanedClause(clause);
}
